<template>
  <div id="newsCard" class="w-[17.8125rem] cursor-pointer rounded-md">
    <div class="relative mb-3 h-[11.875rem]">
      <img :src="detail?.thumbnail" class="object-fill w-full h-full rounded-md" alt="" />
      <template v-if="detail?.has_video">
        <div class="absolute inset-0 rounded-md bg-[rgba(0,0,0,0.74)]"></div>
        <IconPlay class="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[1]">
        </IconPlay>
      </template>
    </div>
    <div class="flex justify-between items-center mb-2">
      <p
        class="text-sm text-main-color font-semibold w-[90%] overflow-hidden text-ellipsis whitespace-nowrap"
      >
        {{ detail?.name }}
      </p>
    </div>
    <div class="flex justify-between items-center mb-3">
      <p class="text-sm text-main-color font-light">{{ isTodayDate(detail?.date_created) }}</p>
      <div class="flex gap-1 items-center">
        <IconEye />
        <p class="text-main-color text-sm font-semibold">{{ detail?.view_count }}</p>
      </div>
    </div>
    <div class="flex items-center gap-2">
      <template v-if="detail?.link_type != null">
        <a
          v-if="detail?.link_type == 0"
          :href="detail?.link"
          class="text-lg overflow-hidden truncate text-[#409DBA] font-semibold mb-3 md:mb-0 hover:text-main-color"
          >{{ detail?.link_text }}
        </a>
        <router-link
          v-else
          :to="{
            name: getRouteParams(detail).name,
            params: getRouteParams(detail).params,
            query: getRouteParams(detail).query,
          }"
          class="text-lg overflow-hidden truncate text-[#409DBA] font-semibold mb-3 md:mb-0 hover:text-main-color"
        >
          {{ detail?.link_text }}
        </router-link>
      </template>
    </div>
    <div
      style="background-color: rgba(96, 165, 250, 0.69)"
      class="px-2 py-0.5 text-sm rounded-sm"
      v-if="showCategory"
    >
      {{ detail.category }}
    </div>
  </div>
</template>

<script>
import { isTodayDate } from '@/helpers';
import IconEye from '@icons/IconEye.vue';
import IconPlay from '@icons/IconPlay.vue';
import { LINK_TYPE } from '@/constants';
import { getRouteParams } from '@/helpers';

export default {
  name: 'NewsCard',
  props: {
    detail: {
      type: Object,
      required: true,
    },
    showCategory: {
      type: Boolean,
      default: () => false,
    },
  },
  components: { IconEye, IconPlay },
  data() {
    return {
      linkType: LINK_TYPE,
    };
  },
  methods: {
    isTodayDate,
    getRouteParams,
  },
  computed: {
    isVideo() {
      if (this.detail?.thumbnail) {
        let conditions = ['.mp4', '.mov', '.avi', '.mkv', '.webm'];
        let fragments = this.detail?.thumbnail.split('.');
        fragments = fragments[fragments.length - 1];
        return conditions.some(el => fragments.includes(el));
      }
      return false;
    },
  },
};
</script>

<style scoped></style>
